// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockMeetTheTeam_container__iozk2","heading":"BlockMeetTheTeam_heading__NV16n","list":"BlockMeetTheTeam_list__tgEYm","listItem":"BlockMeetTheTeam_listItem__FOgWk"};